import '../scss/theme.scss';

// For jquery: see 'bootstrap_italia.libraries.yml'
//import '../../node_modules/jquery/dist/jquery.js';
import '../../node_modules/popper.js/dist/umd/popper.js';
import '../../node_modules/owl.carousel/dist/owl.carousel.js';

import '../../node_modules/bootstrap/dist/js/bootstrap.js';
import '../../node_modules/bootstrap-select/js/bootstrap-select.js';
import '../../node_modules/bootstrap-select/js/i18n/defaults-it_IT.js';
import '../../node_modules/svgxuse/svgxuse.js';

import '../../node_modules/bootstrap-italia/src/js/plugins/polyfills/array.from.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/circular-loader/CircularLoader-v1.3.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/password-strength-meter/password-strength-meter.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/datepicker/locales/it.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/datepicker/datepicker.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/i-sticky/i-sticky.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/sticky-header.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/sticky-wrapper.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/ie.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/fonts-loader.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/autocomplete.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/back-to-top.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/componente-base.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/cookiebar.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/dropdown.js';
//import '../../node_modules/bootstrap-italia/src/js/plugins/forms.js';
import './custom/forms.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/track-focus.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/forward.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/navbar.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/navscroll.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/history-back.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/notifications.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/upload.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/progress-donut.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/list.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/imgresponsive.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/timepicker.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/input-number.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/carousel.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/transfer.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/select.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/rating.js';
import '../../node_modules/bootstrap-italia/src/js/plugins/dimmer.js';

import './custom/example.js';
